import { render, staticRenderFns } from "./TimeDepthAnalyticsTable.vue?vue&type=template&id=053c07da&scoped=true"
import script from "./TimeDepthAnalyticsTable.vue?vue&type=script&lang=ts"
export * from "./TimeDepthAnalyticsTable.vue?vue&type=script&lang=ts"
import style0 from "./TimeDepthAnalyticsTable.vue?vue&type=style&index=0&id=053c07da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c07da",
  null
  
)

export default component.exports